import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../constants/ActionTypes';
import _ from 'lodash';
export var INITIAL_STATE = {
  screens: {},
  sets: {}
};
var INITIAL_SET_STATE = {
  orderByHistory: [],
  orderBySpace: []
};
var INITIAL_SCREEN_DATA = {
  width: null,
  minActiveWidth: null,
  desiredState: 'open' //open/retracted/closing

};

var add = function add(state, action) {
  var screens = _objectSpread({}, state.screens);

  screens[action.lineage] = {
    lineage: action.lineage,
    data: _objectSpread(_objectSpread({}, INITIAL_SCREEN_DATA), action.data)
  };

  var sets = _objectSpread({}, state.sets);

  sets[action.setKey] = _objectSpread(_objectSpread({}, INITIAL_SET_STATE), sets[action.setKey]);
  sets[action.setKey].orderBySpace = [].concat(_toConsumableArray(sets[action.setKey].orderBySpace), [action.lineage]);
  sets[action.setKey].orderByHistory = [].concat(_toConsumableArray(sets[action.setKey].orderByHistory), [action.lineage]);
  return _objectSpread(_objectSpread({}, state), {}, {
    screens: screens,
    sets: sets
  });
};

var addSet = function addSet(state, action) {
  var sets = _objectSpread({}, state.sets);

  sets[action.setKey] = _objectSpread({}, INITIAL_SET_STATE);
  return _objectSpread(_objectSpread({}, state), {}, {
    sets: sets
  });
};

var close = function close(state, action) {
  var screens = _objectSpread({}, state.screens);

  screens[action.lineage] = {
    lineage: action.lineage,
    data: _objectSpread(_objectSpread({}, screens[action.lineage].data), {}, {
      desiredState: 'closing'
    })
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    screens: screens
  });
};

var open = function open(state, action) {
  var screens = _objectSpread({}, state.screens);

  screens[action.lineage] = {
    lineage: action.lineage,
    data: _objectSpread(_objectSpread({}, screens[action.lineage].data), {}, {
      desiredState: 'open'
    })
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    screens: screens
  });
};

var remove = function remove(state, action) {
  var sets = _objectSpread({}, state.sets);

  var orderByHistory = _.without(_toConsumableArray(sets[action.setKey].orderByHistory), action.lineage);

  var orderBySpace = _.without(_toConsumableArray(sets[action.setKey].orderBySpace), action.lineage);

  return _objectSpread(_objectSpread({}, state), {}, {
    sets: _objectSpread(_objectSpread({}, sets), {}, _defineProperty({}, action.setKey, {
      orderByHistory: orderByHistory,
      orderBySpace: orderBySpace
    }))
  });
};

var removeAllScreensFromSet = function removeAllScreensFromSet(state, action) {
  var sets = _objectSpread({}, state.sets);

  return _objectSpread(_objectSpread({}, state), {}, {
    sets: _objectSpread(_objectSpread({}, sets), {}, _defineProperty({}, action.setKey, {
      orderByHistory: [],
      orderBySpace: []
    }))
  });
};

var retract = function retract(state, action) {
  var screens = _objectSpread({}, state.screens);

  screens[action.lineage] = {
    lineage: action.lineage,
    data: _objectSpread(_objectSpread({}, screens[action.lineage].data), {}, {
      desiredState: 'retracted'
    })
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    screens: screens
  });
};

var topHistory = function topHistory(state, action) {
  var sets = _objectSpread({}, state.sets);

  var orderByHistory = _.without(_toConsumableArray(sets[action.setKey].orderByHistory), action.lineage);

  orderByHistory.push(action.lineage);
  return _objectSpread(_objectSpread({}, state), {}, {
    sets: _objectSpread(_objectSpread({}, sets), {}, _defineProperty({}, action.setKey, _objectSpread(_objectSpread({}, sets[action.setKey]), {}, {
      orderByHistory: orderByHistory
    })))
  });
}; // TODO test properly!


var update = function update(state, action) {
  var screens = _objectSpread({}, state.screens);

  screens[action.lineage] = _objectSpread(_objectSpread({}, screens[action.lineage]), {}, {
    data: _objectSpread(_objectSpread({}, screens[action.lineage].data), action.data)
  });

  var sets = _objectSpread({}, state.sets);

  sets[action.setKey] = _objectSpread(_objectSpread({}, INITIAL_SET_STATE), sets[action.setKey]);

  var orderByHistory = _.without(sets[action.setKey].orderByHistory, action.lineage);

  orderByHistory.push(action.lineage);
  sets[action.setKey].orderByHistory = orderByHistory;

  var alreadyInOrder = _.find(sets[action.setKey].orderBySpace, function (lineage) {
    return lineage === action.lineage;
  });

  if (!alreadyInOrder) {
    var orderBySpace = _.without(sets[action.setKey].orderBySpace, action.lineage);

    orderBySpace.push(action.lineage);
    sets[action.setKey].orderBySpace = orderBySpace;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    screens: screens,
    sets: sets
  });
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.SCREENS.ADD:
      return add(state, action);

    case ActionTypes.SCREENS.CLOSE:
      return close(state, action);

    case ActionTypes.SCREENS.OPEN:
      return open(state, action);

    case ActionTypes.SCREENS.REMOVE:
      return remove(state, action);

    case ActionTypes.SCREENS.REMOVE_ALL:
      return removeAllScreensFromSet(state, action);

    case ActionTypes.SCREENS.RETRACT:
      return retract(state, action);

    case ActionTypes.SCREENS.SETS.ADD:
      return addSet(state, action);

    case ActionTypes.SCREENS.TOP_HISTORY:
      return topHistory(state, action);

    case ActionTypes.SCREENS.UPDATE:
      return update(state, action);

    default:
      return state;
  }
});